<div class="billing_product-container" *ngIf="products.length">
  <app-product-card
    *ngFor="let product of products"
    [product]="product"
    [orderCount]="orderAmount"
    (selectedTier)="selectTier($event)"
    [isOnBoarding]="isOnBoarding"
  ></app-product-card>
</div>
<div class="loader loader_show" *ngIf="!products.length">
  <img [src]="'assets/images/nineyard-loading.gif'" />
</div>
<div class="price" *ngIf="tierChange && !isOnBoarding" >
  <div class="price_wrapper">
    <div class="price_group">
      <div class="price_title">Current Billing Amount</div>
      <div class="price_amount">${{ currentPrice }}</div>
    </div>
    <div class="price_group">
      <div class="price_title">Next Billing Date</div>
      <div class="price_amount">{{ nextBillingDate | date: "shortDate" }}</div>
    </div>
    <div class="price_group">
      <div class="price_title">New Monthly Charges</div>
      <div class="price_amount">${{ newPrice ? newPrice : 0 }}</div>
    </div>
  </div>
  <div class="subs_section">
    <app-button (click)="cancel()" [buttonStyle]="'underline'">Cancel</app-button>
    <app-button (click)="saveTier()" [spin]="spin">Confirm</app-button>
  </div>
</div>
